import { Skeleton } from "antd";

const VehicleCardSkeleton = () => (
    <div className="overflow-hidden rounded-2xl border border-[#f0f0f0] bg-white">
        <div className="flex flex-col lg:flex-row">
            <Skeleton.Node active className="!h-52 !w-full !rounded-none lg:!h-auto lg:!min-h-[208px] lg:!w-[280px]" />
            <div className="flex min-w-0 flex-1 flex-col gap-4 p-4 lg:p-5">
                <div className="flex items-start justify-between gap-3">
                    <Skeleton active title={{ width: "45%" }} paragraph={{ rows: 1, width: "65%" }} />
                    <Skeleton.Button active size="small" className="!w-20" />
                </div>
                <div className="flex flex-col gap-3">
                    <div className="flex justify-between gap-4">
                        <Skeleton active paragraph={{ rows: 2, width: ["75%", "90%"] }} />
                        <Skeleton active paragraph={{ rows: 2, width: ["75%", "90%"] }} className="!text-right" />
                    </div>
                    <Skeleton.Node active className="!h-1.5 !w-full !rounded-full" style={{ width: "100%" }} />
                    <div className="grid grid-cols-3 gap-3">
                        <Skeleton.Input active size="small" className="!w-14" />
                        <Skeleton.Input active size="small" className="!mx-auto !w-28" />
                        <Skeleton.Input active size="small" className="!ml-auto !w-14" />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default VehicleCardSkeleton;
